import React from 'react';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import { REFERENCES } from '../../constants/confluenceConstants';
import '../../css/confluence.css';

const References = () => {
  return (
    <ConfluencePage pageName={REFERENCES} />
  );
};

export default References;
